export default "__VITE_ASSET__h6FCbL0m__"